import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Qrcode from '../views/Qrcode.vue'
import BindCompany from '../views/BindCompany.vue'
import Register from '../views/Register.vue'
import Unbinding from '../views/Unbinding.vue'
import NewsList from '../views/NewsList.vue'
import NewsDetails from '../views/NewsDetails.vue'
import Login from '../views/Login.vue'
import PolicyNews from '../views/PolicyNews.vue'
import tjbgList from '../views/tjbgList.vue'
import OpenLaunchWeapp from '../views/OpenLaunchWeapp.vue'
import LhjyCsq from '../views/LhjyCsq.vue'
import Bdcmmjsq from '../views/Bdcmmjsq.vue'
import Index from '../views/Index.vue'
import List from '../views/List.vue'
import RiskController from "@/views/RiskController.vue";

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: {
      title: '双税通'
    }
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    meta: {
      title: '政策法规'
    }
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: '双鸭山税务'
    }
  },
  {
    path: '/qrcode',
    name: 'Qrcode',
    component: Qrcode
  },
  {
    path: '/bindcompany',
    name: 'BindCompany',
    component: BindCompany,
    meta: {
      title: '绑定企业'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/unbinding',
    name: 'Unbinding',
    component: Unbinding,
    meta: {
      title: '绑定企业'
    }
  },
  {
    path: '/newslist',
    name: 'NewsList',
    component: NewsList,
    meta: {
      title: '消息通知'
    }
  },
  {
    path: '/newsdetails',
    name: 'NewsDetails',
    component: NewsDetails,
    meta: {
      title: '消息详情'
    }
  },
  {
    path: '/policynews',
    name: 'PolicyNews',
    component: PolicyNews,
    meta: {
      title: '政策消息'
    }
  },
  {
    path: '/tjbglist',
    name: 'tjbgList',
    component: tjbgList,
    meta: {
      title: '体检报告'
    }
  },
  {
    path: '/openlaunchweapp',
    name: 'OpenLaunchWeapp',
    component: OpenLaunchWeapp,
    meta: {
      title: '双鸭山税务'
    }
  },
  {
    path: '/lhjycsq',
    name: 'LhjyCsq',
    component: LhjyCsq,
    meta: {
      title: '灵活就业人员基本养老保险缴费测算器'
    }
  },
  {
    path: '/bdcmmjsq',
    name: 'Bdcmmjsq',
    component: Bdcmmjsq,
    meta: {
      title: '房产交易税费计算器'
    }
  },
  {
    path: '/riskcontroller',
    name: 'RiskController',
    component: RiskController,
    meta: {
      title: '风险控制器'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
